'use client';

import React, { useId } from 'react';
import { Star, ChevronDown } from 'lucide-react';

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label?: string;
  helperText?: string;
  size?: 'large' | 'medium';
  state?:
    | 'default'
    | 'filled'
    | 'hover'
    | 'focus'
    | 'disabled'
    | 'success'
    | 'info'
    | 'warning'
    | 'error';
  showLeftIcon?: boolean;
  showRightIcon?: boolean;
  leftIcon?: React.ReactNode;   // <-- NOUVEAU
  rightIcon?: React.ReactNode;  // <-- NOUVEAU
  className?: string;
  rightElement?: React.ReactNode;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      placeholder,
      helperText,
      size = 'medium',
      state = 'default',
      disabled = false,
      showLeftIcon = true,
      showRightIcon = true,
      leftIcon,    // <-- Extraction de la prop
      rightIcon,   // <-- Extraction de la prop
      className = '',
      rightElement,
      id,
      name,
      ...props
    },
    ref
  ) => {
    const generatedId = useId();
    const inputId = id || generatedId;
    const inputName = name || (id ? undefined : generatedId);

    const containerClasses = `input-container input-${size}`;
    const labelClasses = `input-label input-label-${state}`;
    const helperClasses = `input-helper input-helper-${state}`;
    // Le wrapper utilise htmlFor → cliquer n'importe où dans le wrapper
    // transfert le focus à l'input natif, même sur les icônes.
    const wrapperClasses = `input-wrapper input-wrapper-${state}`;
    const inputClasses = `input-base input-state-${state}`;

    return (
      <div className={`${containerClasses} ${className}`}>
        {label && (
          <label htmlFor={inputId} className={labelClasses}>
            {label}
          </label>
        )}

        {/* Le <label> englobe le wrapper → tout clic → focus input */}
        <label htmlFor={inputId} className={wrapperClasses}>
          
          {/* GESTION DE L'ICONE GAUCHE */}
          {showLeftIcon && (
            leftIcon ? (
              <span className="input-icon-left flex items-center justify-center" aria-hidden="true">
                {leftIcon}
              </span>
            ) : (
              <Star className="input-icon-left" aria-hidden="true" />
            )
          )}

          <input
            ref={ref}
            id={inputId}
            name={inputName}
            type="text"
            className={inputClasses}
            placeholder={placeholder}
            disabled={disabled}
            {...props}
          />

          {/* GESTION DE L'ICONE DROITE */}
          {showRightIcon && !rightElement && (
            rightIcon ? (
              <span className="input-icon-right flex items-center justify-center" aria-hidden="true">
                {rightIcon}
              </span>
            ) : (
              <ChevronDown className="input-icon-right" aria-hidden="true" />
            )
          )}

          {rightElement && (
            <span className="input-right-element">{rightElement}</span>
          )}
        </label>

        {helperText && (
          <span className={helperClasses}>{helperText}</span>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;